import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Callout from "@churchofjesuschrist/eden-callout";
import { backgroundColorHover, borderColorPrimary, spacing4, spacing8, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { Fade, Scrollable } from "@churchofjesuschrist/eden-fade";
import Footer from "./components/Footer";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCallout = styled(Callout).withConfig({
  componentId: "sc-80kb9u-0"
})(["width:100%;max-width:17.5rem;max-height:min(37.5rem,100vh);display:flex;flex-direction:column;& hr{height:1px;background-color:", ";border:none;margin:0;}&&& label{display:flex;padding:calc(", " + ", ") ", ";justify-content:space-between;}&&& fieldset{display:block;& legend{padding:calc(", " + ", ") ", " ", ";}& label{justify-content:flex-start;}}& label:hover{background:", ";cursor:pointer;}& input:is([type=\"checkbox\"],[type=\"radio\"]){cursor:pointer;}"], borderColorPrimary, spacing8, spacing4, spacing16, spacing8, spacing4, spacing16, spacing8, backgroundColorHover);

/**
 * Use a contextual menu to display a list of links/actions that can be toggled on/off.
 * While similar to eden-callout, this component adds styling to accommodate eden-form-parts.
 */
const ContextualMenu = _ref => {
  let {
    forRef,
    children,
    open,
    arrow = "overlay",
    onClickOutside,
    footer,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs(StyledCallout, {
    forRef: forRef,
    open: open,
    onClickOutside: onClickOutside,
    arrow: arrow,
    ...props,
    children: [/*#__PURE__*/_jsx(Fade, {
      children: /*#__PURE__*/_jsx(Scrollable, {
        children: children
      })
    }), footer ? /*#__PURE__*/_jsx(Footer, {
      children: footer
    }) : null]
  });
};
ContextualMenu.propTypes = {
  /** The ref to which the contextual menu belongs */
  forRef: PropTypes.object.isRequired,
  /** Content inside contextual menu */
  children: PropTypes.node.isRequired,
  /** Content to embed in the footer of the contextual menu. */
  footer: PropTypes.node,
  /** Whether the contextual menu is open */
  open: PropTypes.bool,
  /** Whether the arrow is hidden, overlaid, or normal */
  arrow: PropTypes.oneOf(["none", "normal", "overlay"]),
  /** Handler for when a click occurs outside of the contextual menu (e.g., to close the callout) */
  onClickOutside: PropTypes.func
};
export default ContextualMenu;